import { apiRequest } from './api';

export interface PreviewPlayEventInput {
  trackId: number;
  releaseId?: number;
  source?: string;
}

export interface ArtistViewEventInput {
  artistId: number;
  source?: string;
}

export async function trackPreviewPlay({
  trackId,
  releaseId,
  source,
}: PreviewPlayEventInput): Promise<void> {
  if (!trackId) {
    return;
  }
  try {
    await apiRequest('/analytics/preview-play', {
      method: 'POST',
      body: JSON.stringify({
        track_id: trackId,
        release_id: releaseId,
        source,
      }),
    });
  } catch (error) {
    if (import.meta.env.DEV) {
      console.debug('Failed to record preview play event', error);
    }
  }
}

export async function trackArtistView({
  artistId,
  source,
}: ArtistViewEventInput): Promise<void> {
  if (!artistId) {
    return;
  }
  try {
    await apiRequest('/analytics/artist-view', {
      method: 'POST',
      body: JSON.stringify({
        artist_id: artistId,
        source,
      }),
    });
  } catch (error) {
    if (import.meta.env.DEV) {
      console.debug('Failed to record artist view event', error);
    }
  }
}
